import "./ActionBarButton.scss";

function ActionBarButton(props) {
  //   return <div className="action-bar-button">{props.buttonText}</div>;
  return (
    <div className={props.className}>
      <div
        className="action-bar-button-wrapper"
        onClick={(e) => props.onClick && props.onClick(e)}
      >
        <div className="action-bar-button-icon">{props.icon}</div>
        <div
          className="action-bar-button-text"
          style={props.textColor ? { color: props.textColor } : {}}
        >
          {props.buttonText}
        </div>
      </div>
    </div>
  );
}

export default ActionBarButton;
